import { Button, ButtonSize } from "shared/components";
import {
  ArrowLeft02Icon,
  PlusSignIcon
} from "@hugeicons-pro/core-stroke-rounded";
import { cx } from "shared/utils";

export const ConditionHeader = ({
  editMode,
  onBack,
  onAdd
}: {
  editMode: boolean;
  onBack: () => void;
  onAdd: () => void;
}) => {
  return (
    <header
      className={cx(
        "h-[58px] border-b bg-white border-alpha-100 px-6 flex items-center shrink-0",
        editMode ? "gap-4" : "justify-between"
      )}
    >
      {editMode ? (
        <>
          <Button
            HugeIcon={ArrowLeft02Icon}
            onClick={onBack}
            size={ButtonSize.XS}
            className="!px-3.5"
          >
            Back
          </Button>
          <h1 className="text-base text-content-1000 font-bold">
            Edit condition
          </h1>
        </>
      ) : (
        <>
          <h1 className="text-base text-content-1000 font-bold">
            Active conditions
          </h1>
          <Button
            size={ButtonSize.XS}
            HugeIcon={PlusSignIcon}
            onClick={onAdd}
            className="!px-3.5"
          >
            Add condition
          </Button>
        </>
      )}
    </header>
  );
};
